import { updateState, withDevtools, withFeatureFactory } from '@angular-architects/ngrx-toolkit';
import { computed, inject } from '@angular/core';
import { FilterTaskRequest, Task, TaskService } from '@shared/data-access/data-access-report';
import { tapResponse } from '@ngrx/operators';
import { signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { setPageNumber, setPageSize, withPagination, withPaginationMethods } from '@shared/state/pagination.feature';
import { setError, setFulfilled, setPending, withRequestStatus } from '@shared/state/request-status.feature';
import { pipe, switchMap, tap } from 'rxjs';

export const TaskStore = signalStore(
  withDevtools('task'),
  withState({
    data: null as Task[] | null,
    totalCount: 0,
  }),
  withRequestStatus(),
  withFeatureFactory((store) => withPagination<Task>(store.data, store.totalCount)),
  withComputed(({ data }) => ({
    tasks: computed(() => data()),
  })),
  withMethods((store, taskService = inject(TaskService)) => ({
    load: rxMethod<FilterTaskRequest>(
      pipe(
        tap(({ pageNumber, pageSize, infiniteScroll }) => {
          if (!infiniteScroll) {
            updateState(store, '[TaskStore] Set pending', setPending());
          }

          updateState(store, '[TaskStore] Set page number', setPageNumber(pageNumber));
          updateState(store, '[TaskStore] Set page size', setPageSize(pageSize));
        }),
        switchMap(({ infiniteScroll }) =>
          taskService
            .getUserTasks({
              pageSize: store.pageSize(),
              pageNumber: store.pageNumber(),
              infiniteScroll,
            })
            .pipe(
              tapResponse({
                next: (data) => {
                  updateState(store, '[TaskStore] Set fulfilled', setFulfilled());
                  updateState(store, '[TaskStore] Set data', {
                    totalCount: data.totalTasks,
                    data: !infiniteScroll
                      ? data.userTasksWithReportFullname
                      : [...(store.data() || []), ...data.userTasksWithReportFullname],
                  });
                },
                error: () => {
                  updateState(store, '[TaskStore] Set error', setError());
                  updateState(store, '[TaskStore] Set data', { data: null });
                },
              }),
            ),
        ),
      ),
    ),
  })),
  withFeatureFactory((store) => withPaginationMethods(store)),
);
